import { enableProdMode, importProvidersFrom } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';


import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { LoggingInterceptor } from './app/services/interceptors/logging.interceptor';
import { LoadingInterceptor } from './app/services/interceptors/loading.interceptor';
import { SessionInterceptor } from './app/services/interceptors/session.interceptor';
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from '@angular/common/http';
import { AppInsightsService } from './app/services/app-insights.service';
import { FeatureFlagService } from './app/services/feature.service';
import { DataService } from './app/services/data.service';
import { environment as environment_1 } from 'src/environments/environment';
import { RECAPTCHA_SETTINGS, RecaptchaSettings, RecaptchaFormsModule, RecaptchaModule } from 'ng-recaptcha';
import { DatePipe, CommonModule } from '@angular/common';
import { PlansService } from './app/services/plans.service';
import { EventsManager } from './app/events/events.manager';

const maskConfig: Partial<IConfig> = {
  validation: false,
};



if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, CommonModule, AppRoutingModule, NgbModule, FormsModule, ReactiveFormsModule, RecaptchaFormsModule, RecaptchaModule, NgxMaskModule.forRoot(maskConfig), GoogleMapsModule),
        EventsManager, PlansService, DatePipe,
        {
            provide: RECAPTCHA_SETTINGS,
            useValue: {
                siteKey: environment.recaptcha.siteKey,
            } as RecaptchaSettings,
        },
        DataService,
        FeatureFlagService,
        AppInsightsService,
        { provide: HTTP_INTERCEPTORS, useClass: SessionInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoadingInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: LoggingInterceptor, multi: true },
        provideHttpClient(withInterceptorsFromDi())
    ]
})
  .catch(err => console.error(err));
